import { createWebHistory, createRouter } from "vue-router";

import HomeOnePage from "../components/Pages/HomeOnePage.vue";
// import HomeFinalPage from "../components/Pages/HomeFinalPage.vue";
// import HomeTwoPage from "../components/Pages/HomeTwoPage.vue";
// import HomeThreePage from "../components/Pages/HomeThreePage.vue";
// import HomeFourPage from "../components/Pages/HomeFourPage.vue";
// import HomeFivePage from "../components/Pages/HomeFivePage.vue";
// import HomeSixPage from "../components/Pages/HomeSixPage.vue";
// import HomeSevenPage from "../components/Pages/HomeSevenPage.vue";
// import HomeEightPage from "../components/Pages/HomeEightPage.vue";
// import BlogDetailsPage from "../components/Pages/BlogDetailsPage.vue";
// // import ServiceDetailspage from "../components/Pages/ServiceDetailspage.vue";
// import PortfolioDetailsPage from "../components/Pages/PortfolioDetailsPage.vue";
// import PrivacyPolicyPage from "../components/Pages/PrivacyPolicyPage.vue";
// import TermsOfServicePage from "../components/Pages/TermsOfServicePage.vue";
import ErrorPage from "../components/Pages/ErrorPage.vue";

//SPECIALTIES
import CardiologiePage from "../components/Pages/Specialties/CardiologiePage.vue";
import DiabetologiePage from "../components/Pages/Specialties/DiabetologiePage.vue";
import EndocrinologiePage from "../components/Pages/Specialties/EndocrinologiePage.vue";
import NeurologiePage from "../components/Pages/Specialties/NeurologiePage.vue";
import PsihiatriePage from "../components/Pages/Specialties/PsihiatriePage.vue";
import PsihologiePage from "../components/Pages/Specialties/PsihologiePage.vue";
import ReumatologiePage from "../components/Pages/Specialties/ReumatologiePage.vue";

//DOCTORS
import EduardCoceaPage from "../components/Pages/Doctors/EduardCoceaPage.vue";
import RalucaRomanPage from "../components/Pages/Doctors/RalucaRomanPage.vue";
import GinaNeculaesPage from "../components/Pages/Doctors/GinaNeculaesPage.vue";
import MariaCiocanPage from "../components/Pages/Doctors/MariaCiocanPage.vue";
import XeniaCoceaPage from "../components/Pages/Doctors/XeniaCoceaPage.vue";
import ClaudiuNicolaievPage from "../components/Pages/Doctors/ClaudiuNicolaievPage.vue";
import PetronelaPascaruPage from "../components/Pages/Doctors/PetronelaPascaruPage.vue";
import AlexandraVeronicaMengheresPage from "../components/Pages/Doctors/AlexandraVeronicaMengheresPage.vue";
import AlexandraIoanaNastasaPage from "../components/Pages/Doctors/AlexandraIoanaNastasaPage.vue";

const routes = [
  {
    path: "/",
    name: "HomeOnePage",
    component: HomeOnePage,
  },
  //SPECIALTIES

  {
    path: "/specialitati/cardiologie",
    name: "CardiologiePage",
    component: CardiologiePage,
  },
  {
    path: "/specialitati/diabet_nutritie_si_boli_metabolice",
    name: "DiabetologiePage",
    component: DiabetologiePage,
  },
  {
    path: "/specialitati/endocrinologie",
    name: "EndocrinologiePage",
    component: EndocrinologiePage,
  },
  {
    path: "/specialitati/neurologie",
    name: "NeurologiePage",
    component: NeurologiePage,
  },
  {
    path: "/specialitati/psihiatrie",
    name: "PsihiatriePage",
    component: PsihiatriePage,
  },
  {
    path: "/specialitati/psihologie",
    name: "PsihologiePage",
    component: PsihologiePage,
  },
  {
    path: "/specialitati/reumatologie",
    name: "ReumatologiePage",
    component: ReumatologiePage,
  },

  //DOCTORS
  {
    path: "/echipa_medicala/eduard_cocea",
    name: "EduardCoceaPage",
    component: EduardCoceaPage,
  },
  {
    path: "/echipa_medicala/xenia_cocea",
    name: "XeniaCoceaPage",
    component: XeniaCoceaPage,
  },
  {
    path: "/echipa_medicala/raluca_roman",
    name: "RalucaRomanPage",
    component: RalucaRomanPage,
  },
  {
    path: "/echipa_medicala/gina_neculaes",
    name: "GinaNeculaesPage",
    component: GinaNeculaesPage,
  },
  {
    path: "/echipa_medicala/maria_ciocan",
    name: "MariaCiocanPage",
    component: MariaCiocanPage,
  },
  {
    path: "/echipa_medicala/claudiu_nicolaiev",
    name: "ClaudiuNicolaievPage",
    component: ClaudiuNicolaievPage,
  },
  {
    path: "/echipa_medicala/petronela_pascaru",
    name: "PetronelaPascaruPage",
    component: PetronelaPascaruPage,
  },
  {
    path: "/echipa_medicala/alexandra_veronica_mengheres",
    name: "AlexandraVeronicaMengheresPage",
    component: AlexandraVeronicaMengheresPage,
  },
  {
    path: "/echipa_medicala/alexandra_ioana_nastasa",
    name: "AlexandraIoanaNastasaPage",
    component: AlexandraIoanaNastasaPage,
  },

  // //FROM Template
  // {
  //   path: "/home-final",
  //   name: "HomeFinalPage",
  //   component: HomeFinalPage,
  // },
  // {
  //   path: "/home-two",
  //   name: "HomeTwoPage",
  //   component: HomeTwoPage,
  // },
  // {
  //   path: "/home-three",
  //   name: "HomeThreePage",
  //   component: HomeThreePage,
  // },
  // {
  //   path: "/home-four",
  //   name: "HomeFourPage",
  //   component: HomeFourPage,
  // },
  // {
  //   path: "/home-five",
  //   name: "HomeFivePage",
  //   component: HomeFivePage,
  // },
  // {
  //   path: "/home-six",
  //   name: "HomeSixPage",
  //   component: HomeSixPage,
  // },
  // {
  //   path: "/home-seven",
  //   name: "HomeSevenPage",
  //   component: HomeSevenPage,
  // },
  // {
  //   path: "/home-eight",
  //   name: "HomeEightPage",
  //   component: HomeEightPage,
  // },
  // {
  //   path: "/blog-details",
  //   name: "BlogDetailsPage",
  //   component: BlogDetailsPage,
  // },
  // // {
  // //   path: "/service-details",
  // //   name: "ServiceDetailspage",
  // //   component: ServiceDetailspage,
  // // },
  // {
  //   path: "/gallery-details",
  //   name: "PortfolioDetailsPage",
  //   component: PortfolioDetailsPage,
  // },
  // {
  //   path: "/privacy-policy",
  //   name: "PrivacyPolicyPage",
  //   component: PrivacyPolicyPage,
  // },
  // {
  //   path: "/terms-of-service",
  //   name: "TermsOfServicePage",
  //   component: TermsOfServicePage,
  // },
  { path: "/:pathMatch(.*)*", name: "ErrorPage", component: ErrorPage },
];

const router = createRouter({
  // history: createWebHistory('/'),
   history: createWebHistory(),
  linkExactActiveClass: "active",
  routes: routes,
  scrollBehavior() {
    return { top: 0, behavior: "smooth" };
  },
});

export default router;
